import React from 'react'
import {Redirect, Route} from 'react-router-dom'
import {ROUTES} from '../db/models/const';
import {useAuthState} from 'react-firebase-hooks/auth';
import {auth} from '../firebase';

export const PrivateRoute = ({children, ...rest}) => {
    const [authstate, authstateLoading] = useAuthState(auth);

    return (
        <Route
            {...rest}
            render={() => <>
                {authstateLoading && null}
                {!authstateLoading && authstate && children}
                {!authstateLoading && !authstate && <Redirect to={ROUTES.LOGIN}/>}
            </>}
        />
    );
}
